import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TSupport } from '../types';

import { supportsQueryKeys } from './query-keys';

type TUpdateSupport = {
  id: number;
  name?: string;
  alias?: string[];
};

const patchSupport = ({ id, ...data }: TUpdateSupport): Promise<TSupport> => {
  return mediaManagerClient.patch(`/api/v1/supports/${id}`, data);
};

type MutationFn = typeof patchSupport;

type UseUpdateSupportParams = {
  config?: MutationConfig<MutationFn>;
};

export const useUpdateSupport = ({ config }: UseUpdateSupportParams = {}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el soporte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El soporte se ha actualizado correctamente'));
      queryClient.invalidateQueries({ queryKey: supportsQueryKeys.all });
    },
    ...config,
    mutationFn: patchSupport,
  });
};
